import { createFileRoute } from '@tanstack/react-router';
import { ConsumableSpendReport } from '../../../features/reports/screens/ConsumableSpendReport';

/** Owned by G25. Report #9 — consumable spend by cost centre. */
export const Route = createFileRoute('/_authenticated/reports/consumable-spend')({
  component: ConsumableSpendReport,
});
